import axios from "axios";
import { API_URL } from "../../constants";

export const SaveEventView = async (pid) => {
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    const idArr = sessionStorage.getItem('EIDS');
    var newIdArr = [];
    if (idArr === null) {
        newIdArr.push(pid);
        sessionStorage.setItem('EIDS', JSON.stringify(newIdArr));

        try {
            let res = await axios.get(API_URL + "event/save_view/"+pid, {
                headers: {
                    'Authorization': "Bearer " + token,
                }
            });

        } catch (err) {

        }

    } else {
        newIdArr = JSON.parse(idArr);
        if (!newIdArr.includes(pid)) {
            newIdArr.push(pid);
            sessionStorage.setItem('EIDS', JSON.stringify(newIdArr));

            try {
                let res = await axios.get(API_URL + "event/save_view/"+pid, {
                    headers: {
                        'Authorization': "Bearer " + token,
                    }
                });

            } catch (err) {

            }
        }
    }



}